var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.584,6.788a.336.336,0,0,1-.334-.337V5.1a.336.336,0,0,1,.334-.337h21.2a.336.336,0,0,1,.334.337V6.451a.336.336,0,0,1-.334.337Zm0,8.989a.336.336,0,0,1-.334-.337V14.091a.336.336,0,0,1,.334-.337H31.916a.336.336,0,0,1,.334.337V15.44a.336.336,0,0,1-.334.337Zm0,8.989a.336.336,0,0,1-.334-.337V23.08a.336.336,0,0,1,.334-.337H19.713a.336.336,0,0,1,.334.337v1.348a.336.336,0,0,1-.334.337Z",
    transform: "translate(-2.25 -4.766)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWhite);
export default __webpack_public_path__ + "static/media/menu-white.0e533d9d09555743638c66113703835e.svg";
export { ForwardRef as ReactComponent };